import type { TokenResponse, VisitSnapshotResponse } from '@careflux/telehealth/core';
import type { ClinicianApi } from '@careflux/telehealth/react-query';

export class VideoApiError extends Error {
  constructor(
    public status: number,
    public body: { code?: string }
  ) {
    super('Ekki tókst að framkvæma aðgerð í fjarviðtali.');
  }
}

export const videoRequest = async <T>(path: string, method = 'GET', data?: unknown): Promise<T> => {
  const response = await fetch(`/api/telehealth${path}`, {
    method,
    credentials: 'same-origin',
    cache: 'no-store',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    ...(data === undefined ? {} : { body: JSON.stringify(data) }),
  });
  const body = await response.json();
  if (!response.ok) throw new VideoApiError(response.status, { code: body.code });
  return body as T;
};

export interface VideoConfiguration {
  enabled: boolean;
  portalUrl: string | null;
}

const path = (id: string) => `/visits/${encodeURIComponent(id)}`;

export const clinicianApi = (visitId: string): ClinicianApi => ({
  getSnapshot: () => videoRequest<VisitSnapshotResponse>(path(visitId)),
  admit: (id) => videoRequest(`${path(visitId)}/participants/${encodeURIComponent(id)}/admit`, 'POST'),
  remove: (id) => videoRequest(`${path(visitId)}/participants/${encodeURIComponent(id)}/remove`, 'POST'),
  allow: (id) => videoRequest(`${path(visitId)}/participants/${encodeURIComponent(id)}/allow`, 'POST'),
  end: () => videoRequest(`${path(visitId)}/end`, 'POST'),
});

export const videoToken = (id: string) => videoRequest<TokenResponse>(`${path(id)}/token`, 'POST');
